import apiClient from "@/api/client";
import type { Client, ClientBranch, ClientBranchFormData, ClientFormData, ClientSubBranch, ClientSubBranchFormData } from "@/features/clients/types";
import type { ClientInvoice } from "@/features/finances/types";

const wrap = <T>(res: { data: { data: T } }) => res.data.data;

export const clientsApi = {
  list: () =>
    apiClient.get<{ data: Client[] }>("/clients/").then(wrap),

  get: (id: string) =>
    apiClient.get<{ data: Client }>(`/clients/${id}/`).then(wrap),

  create: (data: ClientFormData) =>
    apiClient.post<{ data: Client }>("/clients/", data).then(wrap),

  update: (id: string, data: Partial<ClientFormData>) =>
    apiClient.patch<{ data: Client }>(`/clients/${id}/`, data).then(wrap),

  delete: (id: string) =>
    apiClient.delete(`/clients/${id}/`),

  invoices: (id: string, params?: { payment_status?: string; overdue?: boolean }) =>
    apiClient
      .get<{ data: ClientInvoice[] }>(`/clients/${id}/invoices/`, { params })
      .then(wrap),
};

export const branchesApi = {
  get: (id: string) =>
    apiClient.get<{ data: ClientBranch }>(`/client-branches/${id}/`).then(wrap),

  update: (id: string, data: Partial<ClientBranchFormData>) =>
    apiClient.patch<{ data: ClientBranch }>(`/client-branches/${id}/`, data).then(wrap),

  delete: (id: string) =>
    apiClient.delete(`/client-branches/${id}/`),
};

export const subBranchesApi = {
  get: (id: string) =>
    apiClient.get<{ data: ClientSubBranch }>(`/client-sub-branches/${id}/`).then(wrap),

  update: (id: string, data: Partial<ClientSubBranchFormData>) =>
    apiClient.patch<{ data: ClientSubBranch }>(`/client-sub-branches/${id}/`, data).then(wrap),

  delete: (id: string) =>
    apiClient.delete(`/client-sub-branches/${id}/`),
};
